<main class="login__layout">
  <div class="main__container">
    <div>
      <img src="./../../../assets/images/new-logo-bmg.svg" width="300" alt="Logo BMG">
    </div>
    <aside class="aside__container">
      <router-outlet></router-outlet>
    </aside>
    <aside class="aside__container">
      <div class="image__login">
        <img src="./../../../assets/images/new-logo-bmg.svg" width="300" style="margin-bottom: 219px;" alt="Logo BMG">
        <div class="button-box">
          <button mat-button class="btnStyle" (click)="downloadPolicyPrivacy()">Política de privacidade de
            dados pessoais</button>
          <button mat-button class="btnStyle" (click)="downloadFraudPrevention()">Política de PLD</button>
        </div>
      </div>
    </aside>
  </div>
</main>
<footer>
  <div class="row row-footer">
    <div class="footer-content">
      Daycoval Seguros. Todos os direitos reservados. Versão {{version}}
    </div>
  </div>
</footer>
